import clsx from 'clsx';
import { Corner, Shadow, ButtonVariant } from '../../utils/utils';
import React, { ButtonHTMLAttributes, CSSProperties } from 'react';
import uiConfig from "../../data/uiConfig"


interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  icon?: React.ReactElement;
  iconRight?: React.ReactElement;
  variant?: ButtonVariant;
  corner?: Corner;
  shadow?: Shadow;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  icon,
  iconRight,
  variant = 'primary',
  corner = uiConfig.button.corner as Corner,
  shadow = uiConfig.button.shadow as Shadow,
  className,
  ...props
}) => {

let btnStyle = "";
switch (variant) {
  case 'primary':
    btnStyle = "bg-primary text-primary-text border-primary hover:bg-primary-600 hover:text-primary-text-hover hover:border-primary-600";
    break;
  case 'secondary':
    btnStyle = "bg-secondary text-secondary-text border-secondary hover:bg-secondary-600 hover:text-secondary-text-hover hover:border-secondary-600";
    break;
  case 'success':
    btnStyle = "bg-success text-success-text border-success hover:bg-success-600 hover:text-success-text-hover hover:border-success-600";
    break;
  case 'alert':
    btnStyle = "bg-alert text-alert-text border-alert hover:bg-alert-600 hover:text-alert-text-hover hover:border-alert-600";
    break;
  case 'info':
    btnStyle = "bg-info text-info-text border-info hover:bg-info-600 hover:text-info-text-hover hover:border-info-600";
    break;
  case 'primary-outline':
    btnStyle = "bg-transparent text-primary border-primary hover:bg-primary hover:text-primary-text hover:border-primary";
    break;
  case 'secondary-outline':
    btnStyle = "bg-transparent text-secondary border-secondary hover:bg-secondary hover:text-secondary-text hover:border-secondary";
    break;
  case 'success-outline':
    btnStyle = "bg-transparent text-success border-success hover:bg-success hover:text-success-text hover:border-success";
    break;
  case 'alert-outline':
    btnStyle = "bg-transparent text-alert border-alert hover:bg-alert hover:text-alert-text hover:border-alert";
    break;
  case 'info-outline':
    btnStyle = "bg-transparent text-info border-info hover:bg-info hover:text-info-text hover:border-info";
    break;
  case 'text':    
    btnStyle = "bg-transparent border-default hover:text-gray-900 hover:border-gray-900 dark:hover:text-gray-300 dark:hover:border-gray-300";
    break;
}

  return (
    <button
      className={clsx(
        'font-semibold transition-all flex items-center justify-center border',
        (icon || iconRight) && !children ? 'w-10 p-2' : 'py-2 px-6',
        (icon || iconRight) && children && 'gap-2',
        btnStyle,
        corner,
        shadow,
        className,
      )}
      {...props}
    >
      {icon && (
        <span className={clsx("flex items-center", !children && 'w-10 justify-center')}>
          {React.isValidElement(icon)
            ? React.cloneElement(icon, { className: 'h-5 w-5' } as React.SVGProps<SVGSVGElement>)
            : icon}
        </span>
      )}
      <span className="flex-1 text-center leading-5">{children}</span>
      {iconRight && (
        <span className="flex items-center">
          {React.isValidElement(iconRight)
            ? React.cloneElement(iconRight, { className: 'h-5 w-5' } as React.SVGProps<SVGSVGElement>)
            : iconRight}
        </span>
      )}
    </button>
  );
};